module.exports = __webpack_public_path__ + "static/media/typographyMarketing3.ee6a63d8.png";